import { defaultApi } from '@/plugins/api/defaultApi'
import { defaultV2Api } from '@/plugins/api/defaultV2Api'
import moment from 'moment'

export default {
  name: 'bnpl',
  namespaced: true,
  state: {
    isPaymentsLoad: false,
    availableAmount: {},
    wrongCredentials: [],
    is2faRequireds: [],
    payments: {
      results: [],
    },
    summarys: {
      baseEndDate: null,
      results: [],
    },
    limitDates: null,
    getAvailableAmountLoading: false,
    availableAmountPromise: null,
    paymentExecuteDelayMin: null,
  },
  mutations: {
    setPayments(state, payments) {
      state.payments = payments
    },
    appendPayments(state, payments) {
      payments.results = state.payments.results.concat(payments.results)
      state.payments = payments
    },
    setSummarys(state, summarys) {
      state.summarys = summarys
    },
    setSummarysBaseEndDate(state, baseEndDate) {
      state.baseEndDate = baseEndDate
    },
    appendSummarys(state, summarys) {
      summarys.results = state.summarys.results.concat(summarys.results)
      state.summarys = summarys
    },
    setAvaliableAmount(state, availableAmount) {
      state.availableAmount = availableAmount
      state.wrongCredentials = availableAmount.mallLimitSet.filter(
        (v) => v.isWrongCredentials === true,
      )
      state.is2faRequireds = availableAmount.mallLimitSet.filter((v) => v.is2faRequired === true)
    },
    setGetAvailableAmountLoading(state, getAvailableAmountLoading) {
      state.getAvailableAmountLoading = getAvailableAmountLoading
    },
    setLimitDates(state, limitDate) {
      state.limitDates = limitDate
    },
    setAvailableAmountPromise(state, availableAmountPromise) {
      state.availableAmountPromise = availableAmountPromise
    },
    setPaymentExecuteDelayMin(state, delayMin) {
      state.paymentExecuteDelayMin = delayMin
    },
    setIsPaymentsLoad(state, isLoad) {
      state.isPaymentsLoad = isLoad
    },
  },
  actions: {
    async getPayments({ commit }, query) {
      const { data } = await defaultApi.getBnplPayments(query)
      commit('setPayments', data)
      commit('setIsPaymentsLoad', true)
      return data
    },
    async getPaymentsAppend({ commit }, query) {
      const { data } = await defaultApi.getBnplPayments(query)
      commit('appendPayments', data)
      return data
    },
    async getAvailableAmount({ commit, state }) {
      if (state.availableAmountPromise) {
        const { data } = await state.availableAmountPromise
        return data
      }
      try {
        commit('setGetAvailableAmountLoading', true)
        const promise = defaultApi.getBnplAvailable()
        commit('setAvailableAmountPromise', promise)
        const { data } = await promise
        commit('setAvailableAmountPromise', null)
        commit('setAvaliableAmount', data)
        return data
      } finally {
        commit('setGetAvailableAmountLoading', false)
      }
    },
    async getPaymentsDetail({}, uuid) {
      const { data } = await defaultApi.getBnplPaymentsDetail(uuid)
      return data
    },
    async savePayment({}, payment) {
      if (payment.uuid) {
        const { data } = await defaultApi.patchBnplPayments(payment)
        return data
      } else {
        const { data } = await defaultApi.postBnplPayments(payment)
        return data
      }
    },
    async deletePayment({}, { uuid }) {
      const data = await defaultApi.deleteBnplPayments(uuid)
      return data
    },
    async getTotalAmount({}) {
      const data = await defaultApi.getTotalAmount()
      return data
    },
    async getSummarys({ commit }, query) {
      const { data } = await defaultApi.getSummary(query)
      commit('setSummarys', {
        results: data,
      })
      return data
    },
    async getSummarysAppend({ commit }, query) {
      const { data } = await defaultApi.getSummary(query)
      commit('appendSummarys', {
        results: data,
      })
      return data
    },
    async getLimitDates({ commit }) {
      const { data } = await defaultApi.getLimitDate()
      commit('setLimitDates', data)
      return data
    },
    async getPreLimits({}, limit) {
      const { data } = await defaultApi.getPreLimit(limit)
      return data
    },
    async getDepositName({}, { uuid }) {
      const { data } = await defaultV2Api.getDepositName(uuid)
      return data
    },
    async getUsersExtraDepositNames({}, query) {
      const { data } = await defaultV2Api.getUsersExtraDepositNames(query)
      return data
    },
    async getPaymentExecuteDelayMin({ commit }) {
      const {
        data: { minutes },
      } = await defaultV2Api.getDelayMinutes()
      commit('setPaymentExecuteDelayMin', minutes)

      return minutes
    },
    /**
     * 삭제 가능한지 검사
     * @param {*} param0
     * @param {*} uuid
     * @returns isValid
     */
    async checkBeforeOrDelete({ dispatch, state }, uuid) {
      const [payment, delayMin] = await Promise.all([
        dispatch('getPaymentsDetail', uuid),
        dispatch('getPaymentExecuteDelayMin'),
      ])

      const editExpiredAt = moment(payment.completedAt).add(state.paymentExecuteDelayMin, 'minutes')

      // 취소 가능 상태 여부
      if (payment.status !== 'pending') {
        await window.$swal.basic.alert2({
          title: '취소가 불가능한 상태입니다.',
          html: `
            <p class="default">
              송금 대기 상태에서만<br />
              취소가 가능합니다.
            </p>
          `,
        })
        return false
      }
      // 취소 가능 시간 여부
      if (moment().isAfter(editExpiredAt)) {
        await window.$swal.basic.alert2({
          title: '송금이 진행 중입니다.',
          html: `
            <p class="default">
              취소 가능한 시간이 지났습니다.<br />
              송금이 진행 될 예정입니다.<br /><br />
              
              송금 취소는 송금 요청 등록 후<br />
              ‘${delayMin}분’ 이내에 가능합니다.<br />
            </p>
          `,
        })
        return false
      }

      return true
    },
  },
}
